import { createActions } from 'redux-actions';

import types from 'state/paymentData/actionTypes';

const { paymentData } = createActions({
  [types.CHANGE_FISCAL_INFO]: ({ field, value }) => ({ field, value }),
  [types.CHANGE_BILLING_CONTACT]: ({ field, value }) => ({ field, value }),
  [types.SELECT_PAYMENT_METHOD]: ({ value }) => ({ value }),
  [types.CHANGE_PAYMENT_TERM]: ({ field, value }) => ({ field, value }),
  [types.submitPaymentData$]: () => ({}),
  [types.changeToCreditCard$]: () => ({}),
});

export default paymentData;
